<mat-spinner *ngIf="loading" [diameter]="32"></mat-spinner>

<span *ngIf="error && !errorMessage">An error occured connecting your Stripe account.</span>
<span *ngIf="error && errorMessage">{{ errorMessage }}</span>
